import {Injectable} from '@angular/core';
import {CustomerStorageService} from '../../account/services/customer-storage.service';
import {CustomerService} from '../../account/services/customer.service';
import {CustomerVatInterface} from '../../account/models/customer-vat.interface';

@Injectable()
export class PriceFormatService {

    private static readonly DEFAULT_VAT_COEF = 1.2;

    private customerVat: CustomerVatInterface | null = null;
    private vatCustomerId: string | null = null;

    constructor(
        private customerStorage: CustomerStorageService,
        private customerService: CustomerService,
    ) {
    }

    get(priceString: string): string {
        const customer = this.customerStorage.getCustomer();
        const price = Math.abs(+(priceString.replace(',', '.')));
        if (this.isProCustomer()) {
            const wrapperPrice = Number(price / this.getVatCoef(customer.id));
            return this.format(wrapperPrice) + ' HT';
        } else {
            return this.format(price);
        }
    }

    /**
     * Format a bill amount: uses the bill's HT total for pro customers when available,
     * otherwise falls back to the TTC amount.
     * dueTtc has no HT counterpart, so it is converted with the customer VAT coefficient.
     */
    getBillAmount(totalTtc: number, totalHt?: number | null, penalityHt: number = 0, dueTtc: number = 0): string {
        if (this.isProCustomer() && totalHt !== null && totalHt !== undefined) {
            const dueHt = dueTtc / this.getVatCoef(this.customerStorage.getCustomer().id);
            return this.format(Math.abs(totalHt - penalityHt + dueHt)) + ' HT';
        }
        return this.get((totalTtc - penalityHt + dueTtc).toFixed(2));
    }

    private isProCustomer(): boolean {
        const siret = this.customerStorage.getCustomer()?.siret;
        return !(siret === null || siret === '' || siret === undefined);
    }

    private format(price: number): string {
        return price.toFixed(2).toString().replace('.', ',') + '€';
    }

    /**
     * Returns the customer VAT coefficient, fetching it once per customer.
     * Falls back to the default coefficient while the request is pending or if it fails.
     */
    private getVatCoef(customerId: string): number {
        if (this.vatCustomerId !== customerId) {
            this.vatCustomerId = customerId;
            this.customerVat = null;
            this.customerService.getCustomerVat().subscribe({
                next: (vat) => {
                    if (this.vatCustomerId === customerId) {
                        this.customerVat = vat;
                    }
                },
                error: () => {},
            });
        }
        return this.customerVat?.coef || PriceFormatService.DEFAULT_VAT_COEF;
    }
}
